<template lang="html">
  <div class="info">
    <h2>{{title}}</h2>
    <table v-if="table">
      <tr v-for="(item, index) in items" :key="index">
        <td class="label key" v-html="$t(item.label)"></td>
        <td class="value" v-html="$t(item.value)"></td>
      </tr>
    </table>
    <ul v-else>
      <li v-for="(item, index) in items" :key="index">
        {{item.value}}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Info',
  props: {
    title: String,
    item: String,
    items: Array,
    table: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.info {
  h2 {
    margin-bottom: ms(0);
  }
}
table {
  width: 100%;
  @include respond-to('desktop') {
    // border: 1px solid yellow;
  }
  @include respond-to('biggie') {
    // border: 1px solid red;
  }
  .key {
    @media screen {
      color: $mid;
    }
    &:after {
      content: ": ";
    }
  }
  td {
    &.label {
    width: 35%;
    }
    &.value {
      width: 65%;
    }
  }
}
</style>
